module.exports = __webpack_public_path__ + "assets/settings_icon.68455249.svg";